export default __webpack_public_path__ + "static/media/treenuts.95ce4d25.svg";